module.exports = __webpack_public_path__ + "static/0081-579a901bd572e8e8a51f120d44edd690.png";